import {
    PDFViewer,
    Document,
    Page,
    View,
    Text,
    StyleSheet,
    Image,
  } from "@react-pdf/renderer";
  import { Modal } from "antd";
  import DSILogo from "../../assets/DST-logo.jpg";
  import SAASTALogo from "../../assets/saasta-logo.png";
  import moment from "moment";

export default function DownloadOverviewResults({ successful, show, onCancel, data, moduleName }) {

     const columnNumber = 0;
     const reportTitle = "Preview " + moduleName + " Upload Results"
    const { overallStatus, totalDuplicates, totalErrors, totalPass, totalRecords, totalWarnings, uploadDate, fileDetails } = data;

    // Define styles
    const styles = StyleSheet.create({
        columnValueSummary: {
            padding: "10px 0 10px 4px",
            textAlign: "left",
            width: 200,
        },
        footer: {
            position: "absolute",
            bottom: 30,
            left: 0,
            right: 0,
            textAlign: "center",
            fontSize: 12,
            color: "grey",
        },
        header: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            marginBottom: 30,
            width: "100%",
        },
        loading: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            marginBottom: 30,
            width: "100%",
        },
        logo: {
            width: 120,
            height: 50,
        },
        metaFieldValue: {
            color: "#000",
            padding: "6px",
            textAlign: "left",
            fontWeight: "ultrabold",
            width: 250,
            fontFamily: "Roboto",
        },
        metaSection: {
            width: "100%",
        },
        reportDesc: {
            textAlign: "left",
            fontSize: 20,
            marginBottom: 30,
        },
        page: {
            flexDirection: "column",
            alignItems: "center",
            fontFamily: "Roboto",
            padding: "1cm",
        },
        subheader: {
            fontSize: 18,
            marginBottom: "0.5cm",
        },
        section: {
            flexDirection: "row",
            fontSize: 12,
            width: "100%",
        },
        table: {
            flexDirection: "row",
            borderBottomWidth: 1,
            borderBottomColor: "#000",
            borderBottomStyle: "solid",
            marginBottom: 10,
            width: "100%",
        },
        headerCell: {
            width: "40%",
            backgroundColor: "#ccc",
            color: "#000",
            fontSize: 12,
            padding: 5,
        },
        headerCellLong: {
            width: "45%",
            backgroundColor: "#ccc",
            color: "#000",
            fontSize: 12,
            padding: 5,
        },
        headerCellShort: {
            width: "15%",
            backgroundColor: "#ccc",
            color: "#000",
            fontSize: 12,
            padding: 5,
        },
        dataCell: {
            width: "40%",
            padding: 5,
            fontSize: 12,
        },
        dataCellShort: {
            width: "15%",
            padding: 5,
            fontSize: 12,
        },
        dataCellLong: {
            width: "45%",
            padding: 5,
            fontSize: 12,
            textAlign: "left",
        },
        title: {
            marginBottom: 10,
            width: "100%",
        },
        pageNumber: {
            position: "absolute",
            fontSize: 10,
            bottom: 10,
            right: 10,
        },
    });

    const isLoading = (loading) => {
        return loading;
    };

    const OverviewPDFResults = ({ data }) => {
        return (
            <Document pageMode="fullScreen">
                <Page key={"page-1"} style={styles.page}>
                    <View style={styles.header}>
                        <Image style={styles.logo} source={DSILogo} />
                        <Image style={styles.logo} source={SAASTALogo} />
                    </View>
                    {renderMetaContents()}
                    <Text style={styles.footer}>
                        Report produced by SEIMS Core System on{" "}
                        {new Date().toLocaleDateString()}
                    </Text>
                    <Text
                        style={styles.pageNumber}
                        render={({ pageNumber, totalPages }) =>
                            `Page ${pageNumber} of ${totalPages}`
                        }
                        fixed
                    />
                </Page>
            </Document>
        );
    };

    const renderMetaContents = () => (
        <View style={styles.metaSection}>
            <View style={styles.title}>
                <Text style={styles.reportDesc}>{moduleName} Upload Results</Text>
            </View>
            <View style={styles.section}>
                <Text style={styles.metaFieldValue}>File name:</Text>
                <Text style={styles.columnValueSummary}>{fileDetails?.filename}</Text>
            </View>

            <View style={styles.section}>
                <Text style={styles.metaFieldValue}>File size:</Text>
                <Text style={styles.columnValueSummary}>{`${Math.round(
                    fileDetails?.fileSize / 1024,
                    0
                )}KB`}</Text>
            </View>
            <View style={styles.section}>
                <Text style={styles.metaFieldValue}>Number columns:</Text>
                <Text style={styles.columnValueSummary}>{columnNumber}</Text>
            </View>
            <View style={styles.section}>
                <Text style={styles.metaFieldValue}>Number of rows:</Text>
                <Text style={styles.columnValueSummary}>{totalRecords}</Text>
            </View>
            <View style={styles.section}>
                <Text style={styles.metaFieldValue}>Number of successful rows:</Text>
                <Text style={styles.columnValueSummary}>{totalPass}</Text>
            </View>
            <View style={styles.section}>
                <Text style={styles.metaFieldValue}>Number of failed rows:</Text>
                <Text style={styles.columnValueSummary}>{totalErrors}</Text>
            </View>
            <View style={styles.section}>
                <Text style={styles.metaFieldValue}>Number of duplicate rows:</Text>
                <Text style={styles.columnValueSummary}>{totalDuplicates}</Text>
            </View>
            <View style={styles.section}>
                <Text style={styles.metaFieldValue}>Number of rows with warning:</Text>
                <Text style={styles.columnValueSummary}>{totalWarnings}</Text>
            </View>
            <View style={styles.section}>
                <Text style={styles.metaFieldValue}>Overall status:</Text>
                <Text style={styles.columnValueSummary}>{overallStatus}</Text>
            </View>
            <View style={styles.section}>
                <Text style={styles.metaFieldValue}>Processed date:</Text>
                <Text style={styles.columnValueSummary}>
                    {moment(uploadDate).format("DD MMM YYYY hh:mm")}
                </Text>
            </View>
        </View>
    );

    const renderFileMeta = () => {
        return data ? (
            <PDFViewer width="100%" height="600">
                <Document pageMode="fullScreen">
                    <Page style={styles.page}>
                        <View style={styles.header}>
                            <Image style={styles.logo} source={DSILogo} />
                            <Image style={styles.logo} source={SAASTALogo} />
                        </View>
                        {renderMetaContents()}
                        <Text style={styles.footer}>
                            Report produced by SEIMS Core System on{" "}
                            {new Date().toLocaleDateString()}
                        </Text>
                        <Text
                            style={styles.pageNumber}
                            render={({ pageNumber, totalPages }) =>
                                `Page ${pageNumber} of ${totalPages}`
                            }
                            fixed
                        />
                    </Page>
                </Document>
            </PDFViewer>
        ) : (
            <PDFViewer>
                <Document>
                    <Page style={styles.page}>
                        <View style={styles.header}>
                            <Image style={styles.logo} source={DSILogo} />
                            <Image style={styles.logo} source={SAASTALogo} />
                        </View>
                        <View>
                            <Text style={styles.reportDesc}>No data...</Text>
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    };


    return (
        <Modal
            open={show}
            title={reportTitle}
            footer={null}
            onCancel={onCancel}
            centered
            width="60%"
        >
            {renderFileMeta()}
        </Modal>
    )
}
